/**
 * Detects the Google Flights Search (GFS) bot by inspecting the browser's
 * User-Agent string.
 * Returns `true` when the UA contains "Google-Travel-Flights" (case-sensitive,
 * matching the documented bot UA literal).
 * When `true`, all GA and TMS tracking execution must be suppressed.
 *
 * @returns {boolean} `true` if the GFS bot User-Agent is detected, `false` otherwise.
 */
export const isGfsBotUserAgent = (): boolean => {
  return navigator.userAgent.includes('Google-Travel-Flights');
};
